var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('iframe',{ref:"mainIframe",staticStyle:{"height":"100%","width":"100%"},attrs:{"src":"/webgl-more/index.html","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }